import pt from '../translations/pt.json';
import en from '../translations/en.json';
import es from '../translations/es.json';

const loadedTranslations = { pt, en, es };

export const getBrowserLanguage = () => {
  if (typeof navigator === 'undefined') return 'pt';
  const browserLang = navigator.language || navigator.userLanguage || 'pt';
  const language = browserLang.split('-')[0]; // 'en-US' => 'en'
  return ['en', 'pt', 'es'].includes(language) ? language : 'en';
};

/**
 * Kept for backward compatibility with index.js startApp
 */
export const initTranslations = async () => {
  return Promise.resolve();
};

export const getTranslations = (lang) => {
  const userLang = lang || getBrowserLanguage();
  const targetLang = ['en', 'pt', 'es'].includes(userLang) ? userLang : 'en';
  return loadedTranslations[targetLang] || loadedTranslations.en;
};
